import React from "react";
import "../../../CSS/main.css";
import FreeSEOImg from "../../../Images/Schools&Programmes/SEO Free Training.png";
import SEOContents from "../../../Images/Schools&Programmes/SEO contents.png";
import SEOBanner from "../../../Images/Schools&Programmes/SEO-Banner.jpg";
import { Link } from "react-router-dom";
import { ScrollToTop } from "../../utils";
import MetaTags from "../../MetaInfo/MetaTags";

const FreeSEO = () => {
  return (
    <>
      <MetaTags
        title={" Free SEO Course in Hyderabad | New Directions Skills"}
        Description={
          "Boost your career with a Free SEO Course in Hyderabad at New Directions Skills. Learn SEO basics, tools & strategies from experts. Limited seats, join now!"
        }
        Keywords={
          "Free SEO training in Hyderabad DDU-GKY SEO course Telangana Government free digital marketing course  SEO training for rural youth  SEO certification course India "
        }
        href={"https://ndskills.in/free-seo-course-in-hyderabad"}
      />
      <img src={SEOBanner} alt="SEOBanner Img" className="img-fluid" />

      <div className="container my-2 my-lg-5">
        {/* ************************* Header Section **************************/}

        <div className="bg-white p-lg4 rounded-4 seo-title text-lg-center">
          <h1 className="fw-bold textColor2 mb-2">
            Unlock Your Future with Free SEO Training for Telangana Rural Youth
          </h1>
          <p className="text-muted mb-md-4 ">
            Powered by <span className="fw-semibold">DDU-GKY</span> & Government
            of India
          </p>
          <p className="text-secondary ">
            Are you a student from rural Telangana with dreams of building a
            successful career in the digital world? Here’s your golden
            opportunity!
            <br />
            <br />
            The{" "}
            <strong>
              Deen Dayal Upadhyaya Grameen Kaushalya Yojana (DDU-GKY)
            </strong>
            , an initiative by the Ministry of Rural Development, Government of
            India, is offering a<strong> Free SEO Training Program</strong> in
            Hyderabad, exclusively for the rural youth of Telangana.
          </p>
        </div>

        {/**************************  What is SEO ************************* */}
        <div
          className="bg-white gap-3 d-flex justify-content-center flex-column flex-md-row  shadow-sm p-3 p-md-5 rounded-4 mt-3 mt-lg-5 w-100 SEO-Contents"
          style={{
            borderLeft: "4px solid  #183b56",
            borderBottom: "4px solid  #183b56",
          }}
        >
          <div className="w-100">
            <h3 className="textColor2  fw-bold mb-md-3">
              What is SEO and Why Learn It?
            </h3>

            <p className="text-secondary  mb-md-4">
              In today’s digital era, businesses rely heavily on online
              visibility.
              <strong> Search Engine Optimization (SEO)</strong> is a powerful
              digital marketing skill that helps websites rank higher on search
              engines like Google. It plays a vital role in online marketing,
              increasing website traffic, and generating leads.
              <br />
              <br />
              By mastering SEO, you open the door to a wide range of high-paying
              job opportunities in
              <strong>
                {" "}
                digital marketing, freelancing, content creation, e-commerce
              </strong>
              , and more.
            </p>
          </div>

          <img
            src={SEOContents}
            alt="SEO Training Overview"
            className="img-fluid rounded-3  shadow-sm"
          />
        </div>

        {/* ************************* Program Highlights **************************/}

        <div
          className="backGroundColor p-1 p-md-4 rounded mt-2 mt-md-5 CourseDetails  shadow-sm"
          style={{ backgroundColor: " #183b56" }}
        >
          <div className="bg-white rounded-4 p-3 p-md-5 shadow-sm border border-light  mt-md-4">
            <h3 className="textColor2 fw-bold text-md-center mb-md-3 ">
              What Does the Program Offer?
            </h3>
            <p className="mb-md-5">
              This free training program is thoughtfully designed to empower
              rural students and bridge the skill gap in the job market. It
              offers:
            </p>

            <div className="row g-2 g-md-4">
              <div className="col-md-6 col-lg-4">
                <div className="border rounded-4 p-md-4 p-2 text-center h-100 shadow-sm">
                  <div className="mb-md-3">
                    <i className="bi bi-journal-bookmark fs-2  text-success"></i>
                  </div>
                  <h5 className="fw-semibold mb-2">100% Free Training</h5>
                  <p className="text-muted ">
                    Learn from certified digital marketing trainers with
                    real-world experience.
                  </p>
                </div>
              </div>

              <div className="col-md-6 col-lg-4">
                <div className="border rounded-4 p-md-4 p-2 text-center h-100 shadow-sm">
                  <div className="mb-md-3">
                    <i className="bi bi-egg-fried fs-2 text-primary"></i>
                  </div>
                  <h5 className="fw-semibold mb-2">Free Food & Stay</h5>
                  <p className="text-muted ">
                    Worry-free hostel living with healthy meals, so you can
                    focus on learning.
                  </p>
                </div>
              </div>

              <div className="col-md-6 col-lg-4">
                <div className="border rounded-4 p-2 p-md-4 text-center h-100 shadow-sm">
                  <div className="mb-md-3">
                    <i className="bi bi-journal-code fs-2 text-warning"></i>
                  </div>
                  <h5 className="fw-semibold mb-2">Job-Oriented Curriculum</h5>
                  <p className="text-muted ">
                    Master SEO skills from basics to advanced, just like pros
                    do.
                  </p>
                </div>
              </div>

              <div className="col-md-6 col-lg-4">
                <div className="border rounded-4 p-md-4 p-2 text-center h-100 shadow-sm">
                  <div className="mb-md-3">
                    <i className="bi bi-briefcase-fill fs-2 text-info"></i>
                  </div>
                  <h5 className="fw-semibold mb-2">100% Placement Support</h5>
                  <p className="text-muted ">
                    Get help landing your first job after completing the course.
                  </p>
                </div>
              </div>

              <div className="col-md-6 col-lg-4">
                <div className="border rounded-4 p-md-4 p-2 text-center h-100 shadow-sm">
                  <div className="mb-md-3">
                    <i className="bi bi-award-fill fs-2 text-danger"></i>
                  </div>
                  <h5 className="fw-semibold mb-2">Govt Certification</h5>
                  <p className="text-muted ">
                    Receive a certificate from DDUGKY & Govt. of India upon
                    completion.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* ****************** Eligibility & Why Choose  *************************/}

          <div className="row  mt-4 Course-Highlights">
            <div className="col-md-6 h-100">
              <div
                className="bg-light rounded p-2 p-md-4 h-100 shadow-sm "
                style={{ borderLeft: "4px solid rgb(238, 119, 48)" }}
              >
                <h3
                  className=" fw-semibold mb-md-3 d-flex align-items-center"
                  style={{
                    color: "rgb(238, 119, 48)",
                  }}
                >
                  <i className="bi bi-people-fill me-2 fs-4 k"></i> Who Can
                  Apply?
                </h3>
                <ul className="mb-md-3 ps-3">
                  <li className="mb-2">Youth from rural areas of Telangana</li>
                  <li className="mb-2">Age between 18 and 35 years</li>
                  <li className="mb-2">
                    Minimum qualification: 10th Pass or Intermediate
                  </li>
                  <li className="mb-2">
                    Must have Aadhaar card and rural proof (ration card, etc.)
                  </li>
                </ul>
                <p className="mt-2 mb-0 fst-italic text-muted">
                  No prior knowledge of SEO or computers is required! If you
                  have the passion to learn and the determination to grow, this
                  training is for you.
                </p>
              </div>
            </div>

            <div className="col-md-6 mt-2  mt-md-0">
              <div
                className="bg-light rounded p-2 p-md-4 h-100 shadow-sm "
                style={{
                  borderLeft: "4px solid rgb(238, 119, 48)",
                }}
              >
                <h3
                  className="fw-semibold mb-md-3 d-flex align-items-center"
                  style={{
                    color: "rgb(238, 119, 48)",
                  }}
                >
                  <i className="bi bi-stars me-2 fs-4 k"></i> Why Choose This
                  Program?
                </h3>
                <p className="mb-md-3">
                  This initiative isn’t just about training — it’s about{" "}
                  <strong>transforming lives</strong>. By offering professional
                  SEO training absolutely free, along with{" "}
                  <strong>meals, stay</strong>, and{" "}
                  <strong>job placement support</strong>, the government is
                  ensuring that rural youth are not left behind in the digital
                  revolution.
                </p>
                <p className="mb-0 text-muted">
                  Whether you want to <strong>work in a company</strong>, become
                  a <strong>freelancer</strong>, or even{" "}
                  <strong>start your own digital business</strong>, this course
                  provides the right foundation.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* ************************* CTA Section ************************* */}

        <div
          className="bg-white p-3 p-md-5 rounded-4 shadow-sm Course-Highlights mt-2 mt-md-5"
          style={{ border: "2px solid #183b56" }}
        >
          <h3 className="textColor2  fw-bold mb-md-3">
            Limited Seats – Apply Now!
          </h3>

          <p className="text-secondary mb-2 mb-md-4">
            Seats are filling fast. Don’t miss your chance to build a digital
            career with full support—
            <strong> training, food, stay, and job assistance</strong>—all at{" "}
            <strong>zero cost</strong>.
          </p>

          <div className=" mb-2 mb-md-5">
            <p className="mb-2 text-muted">
              📍 <strong>Training Location: </strong>
              <Link
                to="https://www.google.co.in/maps/@17.4816458,78.5587343,3a,90y,211.13h,92.17t/data=!3m6!1e1!3m4!1sG_1f65Gy9td9HbmS1E-k3A!2e0!7i13312!8i6656?entry=ttu"
                target="_blank"
                className=" text-decoration-none text-black"
                onClick={ScrollToTop}
              >
                {" "}
                Plot No.59, Road No.1, Brindavan Colony, Dr. A. S. Rao Nagar,
                ECIL, Secunderabad, Hyderabad – 62
              </Link>
            </p>
            <p className="text-muted">
              🗓️ <strong>Next Batch:</strong> Starting Soon!
            </p>
          </div>

          <div className="d-flex justify-content-center seo-button">
            <Link className=" text-decoration-none text-white" to="/Contactus">
              <button className=" btn1 px-4 py-2  rounded-3 shadow-sm">
                Apply Now
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default FreeSEO;
